import templateModalInfo from '../modal/modal-info.html';
import ModalInfoController from '../modal/modal-info.controller';

export default class OoAdminModalInfoController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 */
	constructor($uibModal) {
		this.$uibModal = $uibModal;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;
	}

	async openLinkInformation() {
		try {
			await this.$uibModal.open({
				template:     templateModalInfo,
				controller:   ModalInfoController,
				controllerAs: '$ctrl',
				resolve:      {
					kid: () => this.kid,
				},
			}).result;
		}
		catch (error) {
			if (error !== 'cancel') {
				console.error(error);
			}
		}
	}
}
